<template>
  <div class="rule-wrapper">
    <div class="container">
      <h1>กฎ</h1>
      <button type="button" class="collapsible active">1. ATOM</button>
      <div class="content" style="display: block">
        <div class="tab">
          <button
            id="btnRules"
            class="tablinks1 active"
            @click="openTab('Rules', 'atom')"
          >
            กฎ
          </button>
          <button id="btnTerm" class="tablinks1" @click="openTab('Term', 'atom')">
            ข้อกำหนดและเงื่อนไข
          </button>
        </div>
        <div id="Rules" class="tabcontent1" style="display: block">
          <h2>กติกาเกม - Atom</h2>
          <h2></h2>
          <h3><u>ภาพรวม</u></h3>
          <p>
            <span>
              ATOM เป็นเกมลอตเตอรีออนไลน์ที่รวดเร็วที่ทำงานบนระบบสุ่มตัวเลขสุ่ม (RNG)
              ที่เรียบง่ายและเข้าใจง่าย ระบบจะสร้างตัวเลขสุ่มแต่ละตัวจำนวน 25 เลข
              โดยเริ่มจาก 0 เป็นตัวเลขที่น้อยที่สุดไปจนถึง 9 เป็นตัวเลขที่มากที่สุด
              โดยจัดเรียงในรูปแบบตารางซึ่งประกอบด้วย 5 แถวและ 5 คอลัมน์
              การสุ่มหมายเลขแต่ละตัวสามารถทำซ้ำกันได้ และอาจแสดงหมายเลขเดียวกัน
            </span>
          </p>
          <p>
            <span>
              เพื่อให้มั่นใจว่าเกมจะยุติธรรม ระบบ RNG
              จะสร้างลำดับหมายเลขสุ่มแยกกันสำหรับแต่ละรอบ
              โดยไม่อ้างอิงจากฐานข้อมูลการออกผลหรือประวัติเกมก่อนหน้า
            </span>
          </p>
          <h3>
            <u><span>ประเภทของการเดิมพัน</span></u>
          </h3>
          <p>
            <span>
              ATOM มีการเดิมพัน 2 ประเภท: การเดิมพันทั่วไปและการเดิมพันแบบไลน์
              ประเภทของการเดิมพันในหมวดการเดิมพันทั่วไปหมายถึงผลรวมของตัวเลขทั้งหมด 25
              เลขที่สุ่มได้ ในขณะเดียวกัน
              ประเภทของการเดิมพันในหมวดเดิมพันแบบไลน์อ้างอิงถึงตัวเลขสุ่มทั้งหมด 5
              เลขที่สุ่มได้สำหรับแต่ละไลน์ เช่น เส้น 1 (L1) เส้น 2 (L2) เส้น 3 (L3)
              บรรทัดที่ 4 (L4) และบรรทัดที่ 5 (L5)
            </span>
          </p>
          <table class="list-bet">
            <thead>
              <tr>
                <td
                  width="5.873015873015873%"
                  valign="top"
                  style="
                    border: 1pt solid;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>ลำดับ</span></strong>
                  </p>
                </td>
                <td
                  width="15.079365079365079%"
                  valign="top"
                  style="
                    border-image: none 100% / 1 / 0 stretch;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <strong><span>ประเภทของการเดิมพัน</span></strong>
                  </p>
                </td>
                <td
                  width="11.428571428571429%"
                  valign="top"
                  style="
                    border-image: none 100% / 1 / 0 stretch;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <strong><span>รูปแบบการเดิมพัน</span></strong>
                  </p>
                </td>
                <td
                  colspan="2"
                  width="33.61904761904762%"
                  valign="top"
                  style="
                    border-image: none 100% / 1 / 0 stretch;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <strong><span>การเดิมพันทั่วไป & อัตราต่อรอง</span></strong>
                  </p>
                </td>
                <td
                  colspan="2"
                  width="33%"
                  valign="top"
                  style="
                    border-image: none 100% / 1 / 0 stretch;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <strong><span>การเดิมพันแบบไลน์ & อัตราต่อรอง</span></strong>
                  </p>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  rowspan="2"
                  width="5.873015873015873%"
                  valign="top"
                  style="
                    width: 27.65pt;
                    border-image: none 100% / 1 / 0 stretch;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">1</span>
                  </p>
                </td>
                <td rowspan="2">
                  <p style="text-align: center"><span>สูง/ต่ำ</span></p>
                </td>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>สูง</span></p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span>
                      ผลรวมของตัวเลขที่สุ่มได้ 25 เลขมีค่าเท่ากับหรือมากกว่า 113
                      หรือตั้งแต่ 113 ถึง 225
                    </span>
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">
                      1.95
                    </span>
                  </p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span>
                      ผลรวมของตัวเลขที่สุ่มได้ 5 เลขในบรรทัดที่ 1 (L1), บรรทัดที่ 2 (L2),
                      บรรทัดที่ 3 (L3), บรรทัดที่ 4 (L4) หรือบรรทัดที่ 5 (L5)
                      มีค่าเท่ากับหรือมากกว่า 23 หรือตั้งแต่ 23 ถึง 45
                    </span>
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">
                      1.95
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>ต่ำ</span></p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span>
                      ผลรวมของตัวเลขที่สุ่มได้ 25 เลขมีค่าเท่ากับหรือน้อยกว่า 112
                      หรือตั้งแต่ 0 ถึง 112
                    </span>
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">
                      1.95
                    </span>
                  </p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span>
                      ผลรวมของตัวเลขที่สุ่มได้ 5 เลขในบรรทัดที่ 1 (L1), บรรทัดที่ 2 (L2),
                      บรรทัดที่ 3 (L3), บรรทัดที่ 4 (L4) หรือบรรทัดที่ 5 (L5)
                      มีค่าเท่ากับหรือน้อยกว่า 22 หรือตั้งแต่ 0 ถึง 22
                    </span>
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">
                      1.95
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  rowspan="2"
                  width="5.873015873015873%"
                  valign="top"
                  style="
                    width: 27.65pt;
                    border-image: none 100% / 1 / 0 stretch;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">2</span>
                  </p>
                </td>
                <td rowspan="2">
                  <p style="text-align: center"><span>เลขคี่/เลขคู่</span></p>
                </td>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>เลขคี่</span></p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span>
                      ผลรวมของตัวเลขที่สุ่มได้ 25
                      เลขโดยมีค่าเป็นเลขคี่ในเลขหลักสุดท้ายเป็น 1, 3, 5, 7, หรือ 9
                    </span>
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">
                      1.95
                    </span>
                  </p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span>
                      ผลรวมของตัวเลขที่สุ่มได้ 5 เลขในบรรทัดที่ 1 (L1), บรรทัดที่ 2 (L2),
                      บรรทัดที่ 3 (L3), บรรทัดที่ 4 (L4) หรือบรรทัดที่ 5 (L5)
                      มีค่าเป็นเลขคี่ในเลขหลักสุดท้ายเป็น 1, 3, 5, 7, หรือ 9
                    </span>
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">
                      1.95
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>เลขคู่</span></p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span>
                      ผลรวมของตัวเลขที่สุ่มได้ 25
                      เลขโดยมีค่าเป็นเลขคู่ในเลขหลักสุดท้ายเป็น 0, 2, 4, 6, หรือ 8
                    </span>
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">
                      1.95
                    </span>
                  </p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span>
                      ผลรวมของตัวเลขที่สุ่มได้ 5 เลขในบรรทัดที่ 1 (L1), บรรทัดที่ 2 (L2),
                      บรรทัดที่ 3 (L3), บรรทัดที่ 4 (L4) หรือบรรทัดที่ 5 (L5)
                      มีค่าเป็นเลขคู่ในเลขหลักสุดท้ายเป็น 0, 2, 4, 6, หรือ 8
                    </span>
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">
                      1.95
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  rowspan="2"
                  width="5.873015873015873%"
                  valign="top"
                  style="
                    width: 27.65pt;
                    border-image: none 100% / 1 / 0 stretch;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">3</span>
                  </p>
                </td>
                <td rowspan="2">
                  <p style="text-align: center"><span>แดง/สีดำ</span></p>
                </td>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>แดง</span></p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span>
                      นับจำนวนตัวเลขที่สุ่มได้ 25 เลขเป็น 0, 2, 6, 7 และ 8 มีค่าเป็นสีแดง
                      เท่ากับหรือมากกว่า 13 จำนวน
                    </span>
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">
                      1.95
                    </span>
                  </p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span>
                      นับจำนวนตัวเลขที่สุ่มได้ 5 เลขใน Line 1 (L1), Line 2 (L2), Line 3
                      (L3), Line 4 (L4), หรือ Line 5 (L5) เป็น 0, 2, 6, 7 และ 8
                      มีค่าเป็นสีแดง เท่ากับหรือมากกว่า 3 จำนวน
                    </span>
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">
                      1.95
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>สีดำ</span></p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span
                      >นับจำนวนตัวเลขที่สุ่มได้ 25 เลขเป็น 1, 3, 4, 5 และ 9 มีค่าเป็นสีดำ
                      เท่ากับหรือมากกว่า 13 จำนวน</span
                    >
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span>
                      นับจำนวนตัวเลขที่สุ่มได้ 5 เลขใน Line 1 (L1), Line 2 (L2), Line 3
                      (L3), Line 4 (L4), หรือ Line 5 (L5) เป็น 1, 3, 4, 5 และ 98
                      มีค่าเป็นสีดำ เท่ากับหรือมากกว่า 3 จำนวน.
                    </span>
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">
                      1.95
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  rowspan="2"
                  width="5.873015873015873%"
                  valign="top"
                  style="
                    width: 27.65pt;
                    border-image: none 100% / 1 / 0 stretch;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">4</span>
                  </p>
                </td>
                <td rowspan="2">
                  <p style="text-align: center"><span>สูง/ต่ำ</span></p>
                </td>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>สูง</span></p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span>
                      นับจำนวนตัวเลขที่สุ่มได้ 25 เลขเป็น 5, 6, 7, 8 และ 9 มีค่าเป็นสูง
                      เท่ากับหรือมากกว่า 13 จำนวน
                    </span>
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span>
                      นับจำนวนตัวเลขที่สุ่มได้ 5 เลขใน Line 1 (L1), Line 2 (L2), Line 3
                      (L3), Line 4 (L4), หรือ Line 5 (L5) เป็น 5, 6, 7, 8 และ 9
                      มีค่าเป็นสูง เท่ากับหรือมากกว่า 3 จำนวน.
                    </span>
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>ต่ำ</span></p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span
                      >นับจำนวนตัวเลขที่สุ่มได้ 25 เลขเป็น 0, 1, 2, 3 และ 4 มีค่าเป็นต่ำ
                      เท่ากับหรือมากกว่า 13 จำนวน.</span
                    >
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span
                      >นับจำนวนตัวเลขที่สุ่มได้ 5 เลขใน Line 1 (L1), Line 2 (L2), Line 3
                      (L3), Line 4 (L4), หรือ Line 5 (L5) เป็น 0, 1, 2, 3 และ 4
                      มีค่าเป็นต่ำ เท่ากับหรือมากกว่า 3 จำนวน.</span
                    >
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  rowspan="4"
                  width="5.873015873015873%"
                  valign="top"
                  style="
                    width: 27.65pt;
                    border-image: none 100% / 1 / 0 stretch;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">5</span>
                  </p>
                </td>
                <td rowspan="4">
                  <p style="text-align: center">
                    <span>ฤดูใบไม้ผลิ / ฤดูร้อน / ฤดูใบไม้ร่วง / ฤดูหนาว</span>
                  </p>
                </td>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>ฤดูใบไม้ผลิ</span></p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span
                      >ผลรวมของตัวเลขที่สุ่มได้ 25 เลขมีค่าเท่ากับหรือน้อยกว่า 95
                      หรือตั้งแต่ 0 ถึง 95.</span
                    >
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >7.50</span
                    >
                  </p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span
                      >การเดิมพันเหล่านี้ไม่สามารถใช้ได้ในหมวดหมู่การเดิมพันแบบไลน์.</span
                    >
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"></span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>ฤดูร้อน</span></p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span
                      >ผลรวมของตัวเลขที่สุ่มได้ 25 เลขมีค่ามากกว่า 96 และเท่ากับ 96
                      หรือน้อยกว่า 112 หรือตั้งแต่ 96 ถึง 112.</span
                    >
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >2.30</span
                    >
                  </p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span
                      >การเดิมพันเหล่านี้ไม่สามารถใช้ได้ในหมวดหมู่การเดิมพันแบบไลน์.</span
                    >
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"></span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>ฤดูใบไม้ร่วง</span></p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span
                      >ผลรวมของตัวเลขที่สุ่มได้ 25 เลขมีค่ามากกว่า 113 และเท่ากับ 129
                      หรือน้อยกว่า 129 หรือตั้งแต่ 113 ถึง 129.</span
                    >
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >2.30</span
                    >
                  </p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span
                      >การเดิมพันเหล่านี้ไม่สามารถใช้ได้ในหมวดหมู่การเดิมพันแบบไลน์.</span
                    >
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"></span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>ฤดูหนาว</span></p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span
                      >ผลรวมของตัวเลขที่สุ่มได้ 25 เลขมีค่าเท่ากับหรือมากกว่า 130
                      หรือตั้งแต่ 130 ถึง 225.
                    </span>
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >7.50</span
                    >
                  </p>
                </td>
                <td
                  width="28.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span
                      >การเดิมพันเหล่านี้ไม่สามารถใช้ได้ในหมวดหมู่การเดิมพันแบบไลน์.</span
                    >
                  </p>
                </td>
                <td width="5.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"></span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p></p>
          <p>
            <u><span>การคำนวณการจ่ายเงิน</span></u>
          </p>
          <p>
            <span
              >โปรดอ่านรายละเอียดด้านล่างสำหรับวิธีการคำนวณการจ่ายเงินในการเดิมพันแต่ละประเภทตามอัตราต่อรอง.</span
            >
          </p>
          <table class="table-payout">
            <thead>
              <tr>
                <td
                  colspan="5"
                  width="100%"
                  valign="top"
                  style="
                    width: 472.5pt;
                    border: 1pt solid;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>การเดิมพันทั่วไป: กรณร A</span></strong>
                  </p>
                </td>
              </tr>
            </thead>
            <thead>
              <tr>
                <td
                  colspan="5"
                  width="100%"
                  valign="top"
                  class="container-center"
                  style="
                    width: 472.5pt;
                    border-image: none 100% / 1 / 0 stretch;
                    padding: 0.1in 5.75pt;
                    height: 109.3pt;
                    vertical-align: top;
                  "
                >
                  <img src="/images/rule2_3_1.png" />
                </td>
              </tr>
              <tr>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    border-image: none 100% / 1 / 0 stretch;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>ผล</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>วางเดิมพัน</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>อัตราต่อรอง</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>สถานะ ชนะ / แพ้</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>การจ่ายเงิน</span></strong>
                  </p>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center">
                    <span>ผลรวม @ 143 แต้ม = สูง</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>สูง @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>ต่ำ @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center">
                    <span>ผลรวม @ 143 แต้ม = เลขคี่</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>เลขคี่ @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>เลขคู่ @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center"><span>แดง@13 สีดำ@12</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>แดง @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>สีดำ @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center"><span>สูง@18 ต่ำ@7</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>สูง @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>ต่ำ @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td rowspan="4">
                  <p style="text-align: center">
                    <span>ผลรวม @ 143 แต้ม = ฤดูหนาว</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>ฤดูใบไม้ผลิ @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>7.50</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>ฤดูร้อน @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>2.30</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>ฤดูใบไม้ร่วง @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>2.30</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>ฤดูหนาว @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>7.50</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$750</span></p>
                </td>
              </tr>
            </tbody>
          </table>
          <p></p>
          <table class="table-payout">
            <thead>
              <tr>
                <td
                  colspan="5"
                  width="100%"
                  valign="top"
                  style="
                    width: 472.5pt;
                    border: 1pt solid;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>การเดิมพันทั่วไป: กรณร B</span></strong>
                  </p>
                </td>
              </tr>
            </thead>
            <thead>
              <tr>
                <td
                  colspan="5"
                  width="100%"
                  valign="top"
                  class="container-center"
                  style="
                    width: 472.5pt;
                    border-image: none 100% / 1 / 0 stretch;
                    padding: 0.1in 5.75pt;
                    height: 109.3pt;
                    vertical-align: top;
                  "
                >
                  <img src="/images/rule3_3_1.png" />
                </td>
              </tr>
              <tr>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    border-image: none 100% / 1 / 0 stretch;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>ผล</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>วางเดิมพัน</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>อัตราต่อรอง</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>สถานะ ชนะ / แพ้</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>การจ่ายเงิน</span></strong>
                  </p>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center">
                    <span>ผลรวม @ 108 แต้ม = ต่ำ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>สูง @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>ต่ำ @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center">
                    <span>ผลรวม @ 108 แต้ม = เลขคู่</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>เลขคี่ @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>เลขคู่ @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center"><span>แดง@11 สีดำ@14</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>แดง @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>สีดำ @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center"><span>สูง@10 ต่ำ@15</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>สูง @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>ต่ำ @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
              <tr>
                <td rowspan="4">
                  <p style="text-align: center">
                    <span>ผลรวม @ 108 แต้ม = ฤดูร้อน</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>ฤดูใบไม้ผลิ @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>7.50</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>ฤดูร้อน @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>2.30</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$230</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>ฤดูใบไม้ร่วง @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>2.30</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>ฤดูหนาว @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>7.50</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
            </tbody>
          </table>
          <p></p>
          <table class="table-payout">
            <thead>
              <tr>
                <td
                  colspan="5"
                  width="100%"
                  valign="top"
                  style="
                    width: 472.5pt;
                    border: 1pt solid;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>การเดิมพันแบบไลน์: กรณี A</span></strong>
                  </p>
                </td>
              </tr>
            </thead>
            <thead>
              <tr>
                <td
                  colspan="5"
                  width="100%"
                  valign="top"
                  class="container-center"
                  style="
                    width: 472.5pt;
                    border-image: none 100% / 1 / 0 stretch;
                    padding: 0.1in 5.75pt;
                    height: 109.3pt;
                    vertical-align: top;
                  "
                >
                  <img src="/images/rule2_3_1.png" />
                </td>
              </tr>
              <tr>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    border-image: none 100% / 1 / 0 stretch;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>ผล</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>วางเดิมพัน</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>อัตราต่อรอง</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>สถานะ ชนะ / แพ้</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>การจ่ายเงิน</span></strong>
                  </p>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center">
                    <span>ผลรวม (L2)@ 28 แต้ม = สูง</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>สูง(L2) @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>ต่ำ(L2)@ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center">
                    <span>ผลรวม (L1)@ 19 แต้ม = เลขคี่</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>เลขคี่(L1) @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center">
                    <span>เลขคู่(L1) @ $100</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center">
                    <span>(L3)แดง@5 (L3)สีดำ@0</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>แดง(L3)@$100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>สีดำ(L3)@$100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center">
                    <span>(L4)สูง@4 (L4)ต่ำ@1</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>สูง(L4) @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center">
                    <span>ต่ำ(L4) @ $100</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
            </tbody>
          </table>
          <p></p>
          <table class="table-payout">
            <thead>
              <tr>
                <td
                  colspan="5"
                  width="100%"
                  valign="top"
                  style="
                    width: 472.5pt;
                    border: 1pt solid;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>การเดิมพันแบบไลน์: กรณี B</span></strong>
                  </p>
                </td>
              </tr>
            </thead>
            <thead>
              <tr>
                <td
                  colspan="5"
                  width="100%"
                  valign="top"
                  class="container-center"
                  style="
                    width: 472.5pt;
                    border-image: none 100% / 1 / 0 stretch;
                    padding: 0.1in 5.75pt;
                    height: 109.3pt;
                    vertical-align: top;
                  "
                >
                  <img src="/images/rule3_3_1.png" />
                </td>
              </tr>
              <tr>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    border-image: none 100% / 1 / 0 stretch;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>ผล</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>วางเดิมพัน</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>อัตราต่อรอง</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>สถานะ ชนะ / แพ้</span></strong>
                  </p>
                </td>
                <td
                  width="20%"
                  valign="top"
                  style="
                    width: 94.5pt;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>การจ่ายเงิน</span></strong>
                  </p>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center">
                    <span>ผลรวม (L2)@ 14 แต้ม = ต่ำ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>สูง(L2) @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>ต่ำ(L2)@ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center">
                    <span>ผลรวม (L5)@ 32 แต้ม = เลขคู่</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>เลขคี่(L5) @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center">
                    <span>เลขคู่(L5) @ $100</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center">
                    <span>(L3)แดง@2 (L3)สีดำ@3</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>แดง(L3)@$100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center"><span>สีดำ(L3)@$100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">
                  <p style="text-align: center">
                    <span>(L4)สูง@0 (L4)ต่ำ@5</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>สูง(L4) @ $100</span></p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นแพ้</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>($100)</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center">
                    <span>ต่ำ(L4) @ $100</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>1.95</span></p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>ผู้เล่นชนะ</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center"><span>$195</span></p>
                </td>
              </tr>
            </tbody>
          </table>
          <p></p>
        </div>
        <div id="Term" class="tabcontent1" style="display: block">
          <h2>ข้อกำหนดและเงื่อนไข – ATOM</h2>
          <p style="text-align: left">
            ข้อมูลด้านล่างนี้เป็นข้อกำหนดและเงื่อนไขของ ATOM:
          </p>
          <ol>
            <li>ATOM มีผลกับสมาชิกที่ลงทะเบียนทั้งหมด.</li>
            <li>
              ผลการแข่งขันของตาราง ATOM
              ทั้งหมดจะแสดงบนรายงานผลทันทีและถือเป็นข้อมูลอย่างเป็นทางการ
            </li>
            <li>
              ผู้ให้บริการเกมขอสงวนสิทธิ์ในการยกเลิกหรือยกเลิกผลหรือการเดิมพันที่ได้รับผลกระทบในกรณีที่มีปัญหาทางเทคนิคหรือการทำงานผิดปกติใดๆ
              รวมถึงไม่จำกัดเพียงข้อผิดพลาดของซอฟต์แวร์ ความล้มเหลวของฮาร์ดแวร์
              หรือปัญหาการเชื่อมต่อ.
            </li>
            <li>
              ผู้ให้บริการเกมขอสงวนสิทธิ์ในการยกเลิกหรือยกเลิกผลหรือการเดิมพันที่ได้รับผลกระทบหากมีข้อสงสัยเกี่ยวกับกิจกรรมฉ้อโกง
              การสมรู้ร่วมคิด หรือการกระทำผิดกฎหมายอื่นๆ โดยผู้เล่น.
            </li>
            <li>
              ผู้ให้บริการเกมขอสงวนสิทธิ์ในการยกเลิกหรือยกเลิกผลการแข่งขันหรือการเดิมพันที่ได้รับผลกระทบในกรณีที่เกิดข้อผิดพลาด
              (ผู้ดูแลระบบของผู้ให้บริการเกมแจ้งข้อมูลไม่ถูกต้อง)
              หรือระบบล้มเหลวซึ่งส่งผลให้ใช้ราคาต่อรองที่ไม่ถูกต้องสำหรับ ATOM.
            </li>
            <li>
              การเดิมพันที่ยอมรับโดยมีรหัสผลในการยืนยันครั้งสุดท้ายจะยังคงมีผลแม้ว่าสมาชิกจะออกจากระบบหรือถูกตัดการเชื่อมต่อจากเกมในภายหลังเนื่องจากการเชื่อมต่อไม่ดี
              การตัดการเชื่อมต่อ ฯลฯ
            </li>
            <li>
              หมายเลขตั๋วเดิมพันเป็นหมายเลขอ้างอิงสำหรับการเดิมพันทั้งหมดที่วางและยืนยันสำเร็จแล้ว
              หมายเลขตั๋วเดิมพันถือเป็นการเดิมพันที่ถูกต้อง
              หากไม่ได้สร้างหมายเลขตั๋วเดิมพันหลังจากวางเดิมพัน
              แสดงว่าการเดิมพันนั้นไม่สำเร็จและไม่ถูกต้อง ดังนั้น
              ควรหลีกเลี่ยงการวางเดิมพันซ้ำด้วยธุรกรรมหลายรายการในช่วงวินาทีสุดท้ายของการออกผลปัจจุบัน.
            </li>
          </ol>
        </div>
      </div>
      <button type="button" class="collapsible active">2. ATOM WAR</button>
      <div class="content" style="display: block">
        <div class="tab">
          <button
            id="btnRules2"
            class="tablinks2 active"
            @click="openTab('Rules2', 'atomwar')"
          >
          กฎ
          </button>
          <button id="btnTerm2" class="tablinks2" @click="openTab('Term2', 'atomwar')">
            ข้อกำหนดและเงื่อนไข
          </button>
        </div>
        <div id="Rules2" class="tabcontent2" style="display: block">
          <h2>กติกาเกม – ATOM WAR</h2>
          <h2></h2>
          <h3><u>ภาพรวม</u></h3>
          <p>
            <span>
              ATOM WAR เป็นเวอร์ชันขั้นสูงของ ATOM โดยมีชุดการสุ่ม 9 ตัวเลขแยกกัน 2 ชุด
              โดยเริ่มจาก 0 เป็นตัวเลขต่ำสุดไปจนถึง 9 เป็นตัวเลขสูงสุด
              จัดเรียงและจัดรูปแบบเป็นแถว 3 แถวด้วยตาราง 3 ตาราง
              การสุ่มตัวเลขแต่ละตัวอาจส่งผลให้เลขซ้ำกัน ตัวเลขชุดหนึ่งแสดงผลของฝั่ง
              'ผู้เล่น' ในขณะที่อีกชุดแสดงผลของฝั่ง 'เจ้ามือ'.
            </span>
          </p>
          <p>
            <span>
              ผลรวมของตัวเลขจากทั้งสองฝั่งจะถูกแยกและทำเป็นตารางด้วยการผสมผสานในรูปแบบต่างๆ
              และมีผลสำหรับตัวเลือกการเดิมพันที่แตกต่างกัน
              ซึ่งใช้เป็นข้อมูลอ้างอิงขั้นสุดท้ายในการคำนวณอัตราการชนะและจำนวนเงิน.
            </span>
          </p>
          <p>
            <span>
              เพื่อให้มั่นใจว่าเกมจะยุติธรรม ระบบ RNG
              จะสร้างลำดับหมายเลขสุ่มแยกกันสำหรับแต่ละรอบ
              โดยไม่อ้างอิงจากฐานข้อมูลการออกผลหรือประวัติเกมก่อนหน้า.
            </span>
          </p>
          <h3>
            <u><span>ตัวเลือกการเดิมพัน</span></u>
          </h3>
          <p>
            <span>
              ข้อมูลด้านล่างนี้คือรายการตัวเลือกการเดิมพันที่มีสำหรับ ATOM WAR.
            </span>
          </p>
          <table class="list-bet">
            <thead>
              <tr>
                <td
                  width="5.873015873015873%"
                  valign="top"
                  style="
                    border: 1pt solid;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <strong><span>ลำดับ</span></strong>
                  </p>
                </td>
                <td
                  width="15.079365079365079%"
                  valign="top"
                  style="
                    border-image: none 100% / 1 / 0 stretch;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <strong><span>หัวข้อ</span></strong>
                  </p>
                </td>
                <td
                  width="11.428571428571429%"
                  valign="top"
                  style="
                    border-image: none 100% / 1 / 0 stretch;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <strong><span>ตัวเลือกการเดิมพัน</span></strong>
                  </p>
                </td>
                <td
                  colspan="2"
                  width="67.61904761904762%"
                  valign="top"
                  style="
                    border-image: none 100% / 1 / 0 stretch;
                    background: rgb(227, 236, 254);
                    padding: 0.1in 5.75pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <strong><span>กฎ & อัตราต่อรอง</span></strong>
                  </p>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  rowspan="3"
                  width="5.873015873015873%"
                  valign="top"
                  style="
                    width: 27.65pt;
                    border-image: none 100% / 1 / 0 stretch;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">1</span>
                  </p>
                </td>
                <td rowspan="3">
                  <p style="text-align: center">
                    <span>ผู้เล่น / เจ้ามือ</span>
                  </p>
                </td>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>ผู้เล่น</span></p>
                </td>
                <td
                  width="57.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span>
                      ผลรวมของตัวเลขที่สุ่ม 9
                      ตัวในฝั่งของผู้เล่นจะต้องสูงกว่าฝั่งของเจ้ามือ.
                    </span>
                  </p>
                  <p>
                    <span>
                      ในกรณีที่ผลเสมอ เมื่อผลรวมของทั้งสองฝั่งเท่ากัน
                      การเดิมพันทั้งหมดที่วางในประเภท ผู้เล่นในรอบนั้นจะถูกคืนเงิน.
                    </span>
                  </p>
                </td>
                <td width="10.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center"><span>เจ้ามือ</span></p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >ผลรวมของตัวเลขที่สุ่ม 9
                      ตัวในฝั่งของเจ้ามือจะต้องสูงกว่าฝั่งของผู้เล่น.
                    </span>
                  </p>
                  <p>
                    <span
                      >ในกรณีที่ผลเสมอ เมื่อผลรวมของทั้งสองฝั่งเท่ากัน
                      การเดิมพันทั้งหมดที่วางในประเภท เจ้ามือ ในรอบนั้นจะถูกคืนเงิน.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center"><span>เสมอ</span></p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >ในรอบจะถือว่าเสมอกันเมื่อผลรวมของทั้งสองฝั่งเท่ากัน
                      การเดิมพันทั้งหมดที่วางในทั้งสองฝั่งสำหรับรอบนั้นจะได้รับการคืนเงิน.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >9.00</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  rowspan="6"
                  width="5.873015873015873%"
                  valign="top"
                  style="
                    width: 27.65pt;
                    border-image: none 100% / 1 / 0 stretch;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">2</span>
                  </p>
                </td>
                <td rowspan="6">
                  <p style="text-align: center"><span>สูง / ต่ำ</span></p>
                </td>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>สูง (ผลรวม)</span></p>
                </td>
                <td
                  width="57.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span
                      >ผลรวมของจำนวนสุ่ม 9 จำนวนของทั้งสองฝั่งต้องมากกว่า 81 ผลอยู่ในช่วง
                      81-162.</span
                    >
                  </p>
                </td>
                <td width="10.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center"><span>ต่ำ (ผลรวม)</span></p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >ผลรวมของจำนวนสุ่ม 9 จำนวนของทั้งสองฝั่งต้องไม่เกิน 80 ผลอยู่ในช่วง
                      0-80.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center">
                    <span>สูง (ผู้เล่น)</span>
                  </p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >ผลรวมของจำนวนสุ่ม 9 จำนวนของฝั่งผู้เล่นต้องมากว่า 41 ผลอยู่ในช่วง
                      41-81.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center">
                    <span>ต่ำ (ผู้เล่น)</span>
                  </p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >ผลรวมของจำนวนสุ่ม 9 จำนวนของฝั่งผู้เล่นต้องไม่เกิน 40 ผลอยู่ในช่วง
                      0-40.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center"><span>สูง (เจ้ามือ)</span></p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >ผลรวมของจำนวนสุ่ม 9 จำนวนของฝั่งเจ้ามือต้องมากว่า 41 ผลอยู่ในช่วง
                      41-81.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center"><span>ต่ำ (เจ้ามือ)</span></p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >ผลรวมของจำนวนสุ่ม 9 จำนวนของฝั่งเจ้ามือต้องไม่เกิน 40 ผลอยู่ในช่วง
                      0-40.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  rowspan="6"
                  width="5.873015873015873%"
                  valign="top"
                  style="
                    width: 27.65pt;
                    border-image: none 100% / 1 / 0 stretch;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">3</span>
                  </p>
                </td>
                <td rowspan="6">
                  <p style="text-align: center"><span>เลขคี่ / เลขคู่</span></p>
                </td>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>เลขคี่ (ผลรวม)</span></p>
                </td>
                <td
                  width="57.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span
                      >ผลรวมของจำนวนสุ่มเลข 9 จำนวนจากทั้งสองฝั่งเป็นจำนวนคี่
                      ซึ่งมีเลขหลักสุดท้ายเป็น 1, 3, 5, 7 หรือ 9.</span
                    >
                  </p>
                </td>
                <td width="10.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center"><span>เลขคู่ (ผลรวม)</span></p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >ผลรวมของจำนวนสุ่มเลข 9 จำนวนจากทั้งสองฝั่งเป็นจำนวนคู่
                      ซึ่งมีเลขหลักสุดท้ายเป็น 0, 2, 4, 6 หรือ 8.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center">
                    <span>เลขคี่ (ผู้เล่น) </span>
                  </p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >ผลของฝั่งผู้เล่นที่สุ่ม 9 จำนวนในรูปแบบเลขคี่ จะต้องลงท้ายด้วยเลข
                      1, 3, 5, 7 หรือ 9.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center">
                    <span>เลขคู่ (ผู้เล่น) </span>
                  </p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >ผลของฝั่งผู้เล่นในรูปแบบเลขคู่ จะต้องลงท้ายด้วยเลข 0, 2, 4, 6 หรือ
                      8.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center"><span>เลขคี่ (เจ้ามือ) </span></p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >ผลของฝั่งเจ้ามือในรูปแบบเลขคี่ จะต้องลงท้ายด้วยเลข 1, 3, 5, 7 หรือ
                      9.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center">
                    <span>เลขคู่ (เจ้ามือ) </span>
                  </p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >ผลของฝั่งเจ้ามือในรูปแบบเลขคู่ จะต้องลงท้ายด้วยเลข 0, 2, 4, 6 หรือ
                      8.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  rowspan="6"
                  width="5.873015873015873%"
                  valign="top"
                  style="
                    width: 27.65pt;
                    border-image: none 100% / 1 / 0 stretch;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">4</span>
                  </p>
                </td>
                <td rowspan="6">
                  <p style="text-align: center"><span>สีแดง / สีดำ</span></p>
                </td>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>แดง (ผลรวม) </span></p>
                </td>
                <td
                  width="57.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span
                      >จำนวนของการออกผลแบบสุ่มของทั้งสองฝั่งที่มีผลเป็น 0, 2, 6, 7 หรือ 8
                      จะถือว่าเป็นสีแดง และผลรวมต้องมีอย่างน้อย 10 หรือมากกว่า.</span
                    >
                  </p>
                  <p>
                    <span
                      >ในกรณีที่ผลเสมอ เมื่อจำนวนของ สีแดง และ สีดำ เท่ากัน (เช่น
                      ทั้งคู่มี 9 จำนวน) การเดิมพันทั้งหมดที่วางในประเภท สีแดง
                      ในรอบนั้นจะถูกคืนเงิน.</span
                    >
                  </p>
                </td>
                <td width="10.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center"><span>สีดำ (ผลรวม) </span></p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >จำนวนของการออกผลแบบสุ่มของทั้งสองฝั่งที่มีผลเป็น 1, 3, 4, 5 หรือ 9
                      จะถือว่าเป็นสีดำ และผลรวมต้องมีอย่างน้อย 10 หรือมากกว่า.
                    </span>
                  </p>
                  <p>
                    <span>
                      ในกรณีที่ผลเสมอ การเดิมพันสีดำ ทั้งหมดในรอบนั้นจะถูกคืนเงิน.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center">
                    <span>แดง (ผู้เล่น) </span>
                  </p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >จำนวนของการออกผลแบบสุ่มของผู้เล่นที่มีผลเป็น 0, 2, 6, 7 หรือ 8
                      จะถือว่าเป็นสีแดง และผลรวมต้องมีอย่างน้อย 5 หรือมากกว่า.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center">
                    <span>สีดำ (ผู้เล่น) </span>
                  </p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >จำนวนของการออกผลแบบสุ่มของผู้เล่นที่มีผลเป็น 1, 3, 4, 5 หรือ 9
                      จะถือว่าเป็นสีดำ และผลรวมต้องมีอย่างน้อย 5 หรือมากกว่า.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center"><span>แดง (เจ้ามือ) </span></p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >จำนวนของการออกผลแบบสุ่มของเจ้ามือที่มีผลเป็น 0, 2, 6, 7 หรือ 8
                      จะถือว่าเป็นสีแดง และผลรวมต้องมีอย่างน้อย 5 หรือมากกว่า.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center"><span>สีดำ (เจ้ามือ) </span></p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >จำนวนของการออกผลแบบสุ่มของเจ้ามือที่มีผลเป็น 1, 3, 4, 5 หรือ 9
                      จะถือว่าเป็นสีดำ และผลรวมต้องมีอย่างน้อย 5 หรือมากกว่า.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  rowspan="6"
                  width="5.873015873015873%"
                  valign="top"
                  style="
                    width: 27.65pt;
                    border-image: none 100% / 1 / 0 stretch;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif">5</span>
                  </p>
                </td>
                <td rowspan="6">
                  <p style="text-align: center"><span>สูง / ต่ำ</span></p>
                </td>
                <td style="width: 0.75in">
                  <p style="text-align: center"><span>สูง (ผลรวม) </span></p>
                </td>
                <td
                  width="57.142857142857146%"
                  valign="top"
                  style="
                    width: 3.75in;
                    padding: 0.1in 5.75pt;
                    height: 6.3pt;
                    vertical-align: top;
                  "
                >
                  <p>
                    <span
                      >จำนวนของการออกผลแบบสุ่มของทั้งสองฝั่งที่มีผลเป็น 5, 6, 7, 8 หรือ 9
                      จะถือว่าสูง และผลรวมต้องมีอย่างน้อย 10 หรือมากกว่า.</span
                    >
                  </p>
                  <p>
                    <span
                      >ในกรณีที่ผลเสมอ เมื่อจำนวนของ สูง และ ต่ำ เท่ากัน (เช่น ทั้งคู่มี 9
                      จำนวน) การเดิมพันทั้งหมดที่วางในประเภท สูง
                      ในรอบนั้นจะถูกคืนเงิน.</span
                    >
                  </p>
                </td>
                <td width="10.476190476190476%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center"><span>ต่ำ (ผลรวม) </span></p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >จำนวนของการออกผลแบบสุ่มของทั้งสองฝั่งที่มีผลเป็น 0, 1, 2, 3 หรือ 4
                      จะถือว่าต่ำ และผลรวมต้องมีอย่างน้อย 10 หรือมากกว่า.</span
                    >
                  </p>
                  <p>
                    <span
                      >ในกรณีที่ผลเสมอ การเดิมพันต่ำ (Low)
                      ทั้งหมดในรอบนั้นจะถูกคืนเงิน.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center">
                    <span>สูง (ผู้เล่น) </span>
                  </p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >จำนวนของการออกผลแบบสุ่มของผู้เล่นที่มีผลเป็น 5, 6, 7, 8 หรือ 9
                      จะถือว่าสูง และผลรวมต้องมีอย่างน้อย 5 หรือมากกว่า.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center">
                    <span>ต่ำ (ผู้เล่น) </span>
                  </p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >จำนวนของการออกผลแบบสุ่มของผู้เล่นที่มีผลเป็น 0, 1, 2, 3 หรือ 4
                      จะถือว่าต่ำ และผลรวมต้องมีอย่างน้อย 5 หรือมากกว่า.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center"><span>สูง (เจ้ามือ) </span></p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >จำนวนของการออกผลแบบสุ่มของเจ้ามือที่มีผลเป็น 5, 6, 7, 8 หรือ 9
                      จะถือว่าสูง และผลรวมต้องมีอย่างน้อย 5 หรือมากกว่า.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td width="14.457831325301205%" valign="top">
                  <p style="text-align: center">
                    <span>ต่ำ (เจ้ามือ) </span>
                  </p>
                </td>
                <td width="72.28915662650603%" valign="top">
                  <p>
                    <span
                      >จำนวนของการออกผลแบบสุ่มของเจ้ามือที่มีผลเป็น 0, 1, 2, 3 หรือ 4
                      จะถือว่าต่ำ และผลรวมต้องมีอย่างน้อย 5 หรือมากกว่า.</span
                    >
                  </p>
                </td>
                <td width="13.25301204819277%" valign="top">
                  <p style="text-align: center">
                    <span style="font-size: 13px; font-family: Arial, sans-serif"
                      >1.95</span
                    >
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="Term2" class="tabcontent2" style="display: block">
          <h2>ข้อกำหนดและเงื่อนไข – ATOM WAR</h2>
          <p style="text-align: left">
            ด้านล่างนี้คือข้อกำหนดและเงื่อนไขสำหรับ ATOM WAR:
          </p>
          <ol>
            <li>ATOM WAR มีให้บริการเฉพาะสมาชิกที่ลงทะเบียนเท่านั้น.</li>
            <li>
              ผลจากทุกตารางของ ATOM WAR
              จะถูกแสดงทันทีในรายงานประวัติการออกผลและจะถูกนำไปใช้.
            </li>
            <li>
              ผู้ให้บริการเกมขอสงวนสิทธิ์ในการยกเลิกหรือทำให้การเดิมพันหรือการหมุนใด ๆ
              เป็นโมฆะที่ได้รับผลกระทบจากปัญหาทางเทคนิคหรือความผิดปกติ
              รวมถึงไม่จำกัดเฉพาะปัญหาการเชื่อมต่อ ความล้มเหลวของฮาร์ดแวร์หรือซอฟต์แวร์.
            </li>
            <li>
              ผู้ให้บริการเกมขอสงวนสิทธิ์ในการยกเลิกหรือทำให้การเดิมพันหรือการหมุนใด ๆ
              เป็นโมฆะในกรณีที่สงสัยว่าผู้เล่นมีส่วนเกี่ยวข้องในกิจกรรมที่ทุจริต
              การร่วมมือ หรือการกระทำที่ผิดกฎหมายอื่น ๆ.
            </li>
            <li>
              ผู้ให้บริการเกมขอสงวนสิทธิ์ในการยกเลิกหรือทำให้การเดิมพันหรือการหมุนใด ๆ
              เป็นโมฆะจากข้อผิดพลาด (จากความผิดพลาดของผู้ดูแลระบบของผู้ให้บริการเกม)
              หรือความผิดปกติของระบบ ซึ่งส่งผลให้เกิดอัตราการจ่ายที่ไม่ถูกต้องในเกม ATOM
              WAR.
            </li>
            <li>
              การเดิมพันยังคงได้รับการยอมรับเมื่อได้รับการยืนยันพร้อมหมายเลขการออกผล
              แม้ว่าสมาชิกจะออกจากระบบหรือเชื่อมต่อจากเกมด้วยเหตุผลใดก็ตาม เช่น
              การเชื่อมต่อเครือข่ายที่ไม่ดี การตัดการเชื่อมต่อกะทันหัน เป็นต้น
            </li>
            <li>
              ตั๋วเดิมพัน (ID)
              เป็นรหัสอ้างอิงสำหรับการเดิมพันทั้งหมดที่ถูกวางและยืนยันสำเร็จ ตั๋วเดิมพัน
              (ID) แสดงถึงการเดิมพันที่ถูกต้อง ในกรณีที่ตั๋วเดิมพัน (ID)
              ไม่ถูกสร้างขึ้นหลังจากวางเดิมพัน
              หมายความว่าการเดิมพันนั้นไม่สำเร็จและไม่ถูกต้อง
              ดังนั้นจึงควรหลีกเลี่ยงการวางเดิมพันหลายรายการในวินาทีสุดท้ายของการออกผลปัจจุบัน.
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  head() {
    return {
      title: "rule",
    };
  },
  computed: {
    openTab: () => openTab,
  },
  mounted() {
    var coll = document.getElementsByClassName("collapsible");
    var i;
    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var content = this.nextElementSibling;
        if (content.style.display === "block") {
          content.style.display = "none";
        } else {
          content.style.display = "block";
        }
      });
    }
  },
};

function openTab(cityName, type) {
  var i, tabcontent, tablinks;
  if (type === "atom") {
    tabcontent = document.getElementsByClassName("tabcontent1");
    tablinks = document.getElementsByClassName("tablinks1");
  } else if (type === "atomwar") {
    tabcontent = document.getElementsByClassName("tabcontent2");
    tablinks = document.getElementsByClassName("tablinks2");
  }
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  for (i = 0; i < tablinks.length; i++) {
    // console.log('tablinks', tablinks[i].id);
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  document.getElementById("btn" + cityName).className += " active";
}
</script>

<style>
body,
#app {
  background: #fff;
  color: #869ab8;
  font-family: "Lato";
  font-size: 1rem;
}
h1,
h2 {
  color: #161c2d;
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 30px;
}

h3 {
  font-size: 14px;
  margin: 0;
}

thead {
  color: black;
}
ol {
  text-align: left;
}

table {
  border: 1px solid #292a2e;
}

td {
  vertical-align: top;
  padding: 0.1in 5.75pt;
}

.rule-wrapper {
  text-align: left;
  /* padding: 80px 0; */
}
.rule-wrapper a {
  color: #1652f0;
  text-decoration: none;
}

.tablestyle {
  border-spacing: 0;
  border-collapse: separate !important;
  width: 100%;
  text-align: center;
}

.tablestyle thead th {
  background: #37405a;
  color: #b0bfd3;
  font-weight: normal;
  /*border-left: 1px solid #4A82F0;
    border-bottom: 1px solid #4A82F0;*/
}

.tablestyle th,
.tablestyle td {
  padding: 2px 10px;
  background: #fff;
  color: #4d4f5c;
}

.tablestyle .currency {
  text-align: right;
}

.tablestyle tbody tr td {
  vertical-align: top;
}

.tablestyle tbody tr:nth-of-type(2n + 0) td {
  background: #f2f6fe;
}

.input-group .form-control {
  border: 0;
}

.input-group-text {
  background: #fff;
  border: 0;
  line-height: normal;
}
.pull-right {
  float: right;
}

.resulticon {
  margin: 0 auto;
  display: block;
  font-size: 10px;
  background-color: #999;
  text-align: center;
  height: 18px;
  width: 18px;
  line-height: 18px;
  border-radius: 18px;
  cursor: pointer;
  color: #fff;
  font-weight: bold;
}

h5 {
  background: #292a2e;
  color: #fff;
  line-height: 50px;
  height: 50px;
  width: 100%;
}

.paragraphy-style {
  text-align: left;
  padding-left: 16px;
  padding-right: 16px;
}

.tablestyle td,
.tablestyle th {
  padding: 10px;
}

.tablecont {
  padding-left: 16px;
  padding-right: 16px;
}

.table-border {
  border-bottom: 1px solid #e3ecfe;
}

@media screen and (max-width: 480px) {
  .tablestyle td,
  .tablestyle th {
    padding: 5px;
    border-right: 1px solid #37405a;
  }
}

/* Style the tab */
.tab {
  overflow: hidden;
  width: inherit;
  /* filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr='#FDFCFC', endColorstr='#FBF9F9'); */
}

/* Style the buttons inside the tab */
.tab button {
  float: left;
  margin: 0;
  background-color: #f2f0f0;
  border: 1px solid #c0c0c0;
  color: #444;
  text-shadow: 0 1px #eee;
  outline: none;
  height: 100%;
  cursor: pointer;
  padding: 14px;
  width: 50%;
  transition: 0.3s;

  font-family: sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 16px;
  /* background-image: linear-gradient(top, #FDFCFC, #FBF9F9 50%, #F7F5F6 50%, #F2F0F0);  */
  background-image: -webkit-linear-gradient(
    top,
    #fdfcfc,
    #fbf9f9 50%,
    #f7f5f6 50%,
    #f2f0f0
  );
  /* display: inline-block; */
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: white;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: white !important;
  background-image: -webkit-linear-gradient(top, white, white 50%, white 50%, white);
  border-bottom: none;
}

/* Style the tab content */
.tabcontent1,
.tabcontent2,
.tabcontent3 {
  text-align: left;
  display: none;
  border: 1px solid #ccc;
  border-top: none;
  animation: fadeEffect 1s;
  padding: 40px 10px;
  overflow: scroll;
}

.center {
  text-align: center;
}
.table-payout {
  text-align: center;
  width: 100%;
}
.container-center {
  text-align: -webkit-center;
}
.left {
  text-align: left;
}
.list-bet {
  text-align: center;
  padding: 0.1in 5.75pt;
}
.list-bet tr td:nth-child(2) {
  /* I don't think they are 0 based */
  text-align: left;
  padding: 0.1in 5.75pt;
}
.list-bet tr td:nth-child(4),
.list-bet tr td:nth-child(6) {
  /* I don't think they are 0 based */
  text-align: left;
  padding: 0.1in 5.75pt;
}

/* Go from zero to full opacity */
@keyframes fadeEffect {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
button {
  border-radius: 0;
}
.collapsible {
  color: black !important;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border-bottom: none;
  border: 1px solid #c0c0c0;
  text-align: left;
  outline: none;
  font-family: sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 18px;
  background-image: -webkit-linear-gradient(
    top,
    #fdfcfc,
    #fbf9f9 50%,
    #f7f5f6 50%,
    #f2f0f0
  );
  position: relative;
}

.active,
.collapsible:hover {
  background-image: -webkit-linear-gradient(top, white, white 50%, white 50%, white);
}

td {
  border: 1pt solid;
}
.content {
  display: none;
  overflow: hidden;
  background-color: white;
}

@media (max-width: 540px) {
  button {
    font-size: 13px !important;
  }
}

button.collapsible:before {
  content: "";
  position: absolute;
  /* border-width: 5px 5px 0 0; */
  /* border-color: #000; */
  display: block;
  width: 10px;
  height: 10px;
  /* background: #f00; */
  border-right: 2px solid #000;
  border-top: 2px solid #000;
  transform: rotate(-45deg);
  right: 30px;
  top: 24px;
  transition: 0.6s all;
}

button.collapsible.active:before {
  transform: rotate(-225deg);
  top: 21px;
}

.top-navbar {
  text-align: center;
  background: #292a2e;
  line-height: 50px;
  height: 50px;
  width: 100%;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

.back-arrow {
  color: #fff;
  font-size: 24px;
  float: left;
  height: 24px;
  line-height: 24px;
  position: absolute;
  left: 4px;
  top: 14px;
}

.back-arrow:hover {
  color: #fff;
  text-decoration: none;
}

.gli {
  text-align: center;
}

.gli a {
  text-decoration: underline;
}
</style>
